import 'bootstrap';

//import "primereact/resources/themes/bootstrap4-light-blue/theme.css";  //theme
import 'styles/themes/saga-blue-custom.css';
import "primereact/resources/primereact.min.css";          //core css
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'styles/adminlte.core.css';
import 'styles/adminlayout.scss';
import 'styles/custom-scroll.scss';
import 'styles/loadingoverlay-ui.scss';
import React, { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import {
    Routes,
    Route,
    Link,
    useNavigate,
    useLocation,
    Navigate,
    Outlet,
    // Redirect,
} from 'react-router-dom';
import { BrowserRouter } from "react-router-dom";
import { fakeAuthProvider } from './auth';
import AuthLayout from './layouts/AuthLayout';
import { store, persistor } from './store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import OtherLayout from 'layouts/learner/thitructuyen/OtherLayout';
import OverViewExam from 'layouts/learner/thitructuyen/components/exam/OverviewExam';
import ExamDetail from 'layouts/learner/thitructuyen/components/exam/ExamDetail';
import StartExam from 'layouts/learner/thitructuyen/components/exam/StartExam';
import StartExamGrammar from 'layouts/learner/thitructuyen/components/exam/StartExamGrammar';
import StartExamNoi from 'layouts/learner/thitructuyen/components/exam/StartExamNoi';
import StartExamViet from 'layouts/learner/thitructuyen/components/exam/StartExamViet';
import ReviewExam from 'layouts/learner/thitructuyen/components/exam/ReviewExam';
import ExamResult from 'layouts/learner/thitructuyen/components/exam/ExamResult';
import PublicExamResult from 'layouts/learner/thitructuyen/components/exam/PublicExamResult';
import PublicReviewExam from 'layouts/learner/thitructuyen/components/exam/PublicReviewExam';
import ExamHistory from 'layouts/learner/thitructuyen/components/exam/ExamHistory';
import ManHinhCho from 'layouts/ManHinhCho';
import GiamSatThi from 'layouts/giamSatThi';
import LoginGiamThi from 'layouts/giamsatthi/LoginGiamThi';
import RequireGiamThi from 'layouts/giamsatthi/RequireGiamThi';
import { loginService } from 'services/loginService';
import { useDispatch, useSelector } from 'react-redux';
import { TIME_CHECK_USER } from 'shared/app-settings';

// Component để redirect từ /overview đến /examdetail với dạng bài thi đầu tiên
function OverviewRedirect() {
    const navigate = useNavigate();

    useEffect(() => {
        // Set dạng bài thi đầu tiên (NGUPHAP) và điều hướng đến examdetail
        localStorage.setItem('typeExam', 'NGUPHAP');
        navigate('/examdetail');
    }, [navigate]);

    return null;
}

export default function App() {
    let User_Id = localStorage.getItem('User_Id');
    let access_token = localStorage.getItem('access_token');

    useEffect(() => {
        // Hàm ngăn chặn hiển thị menu chuột phải
        const handleContextMenu = (e: any) => {
            e.preventDefault();
        };

        // Hàm ngăn chặn các phím tắt sao chép/dán (Ctrl+C, Ctrl+V, Ctrl+X)
        const handleKeyDown = (e: any) => {
            const forbiddenKeys = ['c', 'v', 'x'];
            if ((e.ctrlKey || e.metaKey) && forbiddenKeys.includes(e.key.toLowerCase())) {
                e.preventDefault();
            }
        };

        const handlePaste = (e: any) => {
            e.preventDefault();
        };

        // Thêm các sự kiện vào document
        document.addEventListener('contextmenu', handleContextMenu);
        document.addEventListener('keydown', handleKeyDown);
        document.addEventListener('paste', handlePaste);

        // Cleanup khi component unmount
        return () => {
            document.removeEventListener('contextmenu', handleContextMenu);
            document.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('paste', handlePaste);
        };

    }, []);

    useEffect(() => {
        const disableShortcuts = (event: any) => {
            if (
                (event.ctrlKey || event.metaKey) &&
                (event.key === 's' || event.key === 'u' || event.key === 'p' || event.key === 'v')
                || event.key === 'F12'
            ) {
                event.preventDefault();
            }
        };

        const disableRightClick = (event: any) => {
            event.preventDefault();
            // alert('Chuột phải đã bị vô hiệu hóa!');
        };

        document.addEventListener('keydown', disableShortcuts);
        document.addEventListener('contextmenu', disableRightClick);

        return () => {
            document.removeEventListener('keydown', disableShortcuts);
            document.removeEventListener('contextmenu', disableRightClick);
        };
    }, []);

    useEffect(() => {
        window.addEventListener('beforeprint', function (event) {
            event.preventDefault();
            document.body.innerHTML = "<h1>Có lỗi xảy ra.</h1>";
        });

        window.addEventListener('afterprint', function () {
            location.reload(); // Tải lại trang sau khi thoát chế độ in
        });

        // document.addEventListener('copy', function (event) {
        //     event.preventDefault();
        //     document.body.innerHTML = "<h1>Có lỗi xảy ra.</h1>";
        // });

        document.addEventListener('contextmenu', function (event) {
            event.preventDefault();
        });

        window.addEventListener('load', function () {
            if (!navigator.onLine) {
                document.body.innerHTML = '<h1>Có lỗi xảy ra.</h1>';
            }
        });

        window.addEventListener('load', function () {
            // Kiểm tra xem trang được mở từ tệp địa phương (file://)
            if (window.location.protocol === 'file:') {
                // Thay đổi nội dung của trang khi được mở từ một tệp HTML
                document.body.innerHTML = "<h1>Có lỗi xảy ra.</h1>";
            }
        });


    }, []);


    // useEffect(() => {
    //     const disableInteraction = () => {
    //         const threshold = 160;
    //         const devToolsOpen =
    //             window.outerWidth - window.innerWidth > threshold ||
    //             window.outerHeight - window.innerHeight > threshold;

    //         if (devToolsOpen) {
    //             document.body.innerHTML = "<h1>Trang web không hỗ trợ khi mở DevTools</h1>";
    //         }
    //     };

    //     const interval = setInterval(disableInteraction, 1000);
    //     return () => clearInterval(interval);
    // }, []);

    useEffect(() => {
        // loadApi();
        // const interval = setInterval(() => {
        //     loadApi();
        // }, TIME_CHECK_USER ?? 5000); //TIME_CHECK_USER

        // return () => clearInterval(interval);
    }, []);

    const loadApi = async () => {
        if (access_token && access_token != '') {
            let body = {
                userId: User_Id,
                access_token: access_token
            }
            let data = await loginService.checkUserStatus(body);
            if (!data?.data?.status) {
                onDangXuat();
            }
        }
    }

    const onDangXuat = async () => {
        const body = {
            id: User_Id,
            is_login: 0
        }

        let result = await loginService.updateUser(body)
        localStorage.clear();
        window.location.href = '/'
    }

    return (
        <Sentry.ErrorBoundary fallback={<div style={{textAlign:'center',padding:'50px'}}><h2>Đã xảy ra lỗi. Vui lòng tải lại trang.</h2><button onClick={()=>window.location.reload()} style={{padding:'10px 20px',marginTop:'20px',cursor:'pointer'}}>Tải lại</button></div>}>
        <Provider store={store}>
            <PersistGate persistor={persistor}>
                <AuthProvider>
                    <BrowserRouter>

                        <Routes>
                            {/* <Route path="/thitructuyen" element={<OtherLayout />} /> */}
                            <Route path="/overview" element={<OverviewRedirect />} />
                            <Route path="/examdetail" element={<ExamDetail />} />
                            <Route path="/startexam" element={<StartExam />} />
                            <Route path="/startexamgrammar" element={<StartExamGrammar />} />
                            <Route path="/review-exam/:attemptCode" element={<ReviewExam />} />
                            <Route path="/startexamnoi" element={<StartExamNoi />} />
                            <Route path="/startexamviet" element={<StartExamViet />} />
                            <Route path="/resultexam" element={<ExamResult />} />
                            <Route path="/public-result/:userId/:dethiId" element={<PublicExamResult />} />
                            <Route path="/public-result/:userId" element={<PublicExamResult />} />
                            <Route path="/public-review/:userId/:attemptCode" element={<PublicReviewExam />} />
                            <Route path="/examhistory" element={<ExamHistory />} />
                            <Route path="/overviewexam" element={<OverViewExam />} />
                            <Route path="/xac-nhan-thanh-toan-mb" element={<ManHinhCho />} />

                            {/* ==== GIAM SAT THI ==== */}
                            <Route path="/giam-sat-thi/login" element={<LoginGiamThi />} />
                            <Route element={<RequireGiamThi />}>
                                <Route path="/giam-sat-thi" element={<GiamSatThi />} />
                            </Route>
                            <Route element={<Layout />}>

                                <Route element={<RequireAuth />}>
                                    <Route path='*' element={<AuthLayout />} />
                                </Route>

                            </Route>

                        </Routes>

                    </BrowserRouter>
                </AuthProvider>
            </PersistGate>
        </Provider>
        </Sentry.ErrorBoundary>
    );
}
function Layout() {

    return (
        <Outlet />
    );
}

interface AuthContextType {
    user: any;
    signin: (user: string, callback: VoidFunction) => void;
    signout: (callback: VoidFunction) => void;
}

let AuthContext = React.createContext<AuthContextType>(null!);

function AuthProvider({ children }: { children: React.ReactNode }) {

    let [user, setUser] = React.useState<any>(null);

    let signin = (newUser: string, callback: VoidFunction) => {
        return fakeAuthProvider.signin(() => {
            setUser(newUser);
            callback();
        });
    };

    let signout = (callback: VoidFunction) => {
        return fakeAuthProvider.signout(() => {
            setUser(null);
            callback();
        });
    };

    let value = { user, signin, signout };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

function useAuth() {
    return React.useContext(AuthContext);
}

function RequireAuth() {
    let navigate = useNavigate();
    const oauthStore = useSelector((state: any) => state.oauth);
    let location = useLocation();
    return <Outlet />;
}



function PublicPage() {
    console.log('Public')
    return <h3>Public</h3>;
}

function NotFound() {
    return <h3>NotFound</h3>;
}
